import clients from "../config/client.json";

export function getClientConfig() {
  const clientKey = process.env.REACT_APP_CLIENT_KEY;
  if (!clientKey) {
    throw new Error("CLIENT_KEY is not set in environment variables.");
  }

  const config = (clients as Record<string, any>)[clientKey];

  if (!config) {
    throw new Error(`No config found for client key: ${clientKey}`);
  }

  return config;
}
